import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, Inject, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'

import { fromEvent, merge, Observable, of as observableOf, Subject } from 'rxjs'
import { map, startWith } from 'rxjs/operators'
import { ResponseWarehouseProductsLocation, ResponseWarehouseProductsLocationWitout } from 'src/app/_models'
export interface ProduuctsSelect {
  id: number
  ItemNumber: string
  ItemDescription: string
  ItemDescription1: string
  UnitMeasureType: number
}
@Component({
  selector: 'app-warehouse-name-location',
  templateUrl: './warehouse-name-location.component.html',
  styleUrls: ['./warehouse-name-location.component.css']
})
export class WarehouseNameLocationComponent implements OnInit {
  activeEdit=true;
  isedit=false;
  idEdit=0;
  idproduct=0;
  ResponseWarehouseProductsLocation:ResponseWarehouseProductsLocation[];
  ResponseWarehouseProductsLocationWitout:ResponseWarehouseProductsLocationWitout[];
  DatosSelectProduct: any
  viewminOrder=false;
  ArrayProdutsItems = []
  formWarehouseLocationAdd: FormGroup
  formWarehouseLocationAddWithout: FormGroup
  viewProdust = false
  viewLocation = false
  PlaceOrderCustomer = []
  datosinicio = ''
  @ViewChild('auto') autocomplete: MatAutocompleteTrigger
  myControl = new FormControl()
  options: ProduuctsSelect[] = []
  options2: ProduuctsSelect[] = []
  filteredOptions: Observable<ProduuctsSelect[]>
  ArrayLocations = []
  viewform=true
  constructor (
    private _httpClient: HttpClient,
    private formbuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<WarehouseNameLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.PlaceOrderCustomer = []
    this.PlaceOrderCustomer = data.PlaceOrderCustomer
    this.ArrayProdutsItems = []
    this.ArrayLocations = []
    this.ResponseWarehouseProductsLocation=[]
    this.ResponseWarehouseProductsLocationWitout=[];
    this.viewform=data.view;
    this.OnSelectLocations()
    if (this.viewform) {
      this.onTableLocationWarehouse();
    } else {
      this.onTableLocationWarehouseWithout();
    }
 
  }

  onNoClick (): void {
    this.dialogRef.close()
  }

  ngOnInit (): void {
    this.formWarehouseLocationAdd = this.formbuilder.group({
      Customer: [''],
      product: [this.myControl],
      location: [''],
      minOrder: [1]
      ,Active:[1]
    })
    this.formWarehouseLocationAddWithout = this.formbuilder.group({
      
      location: ['']
     
    })
  }
  OnSelectLocations () {
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/SerchLocations`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.ArrayLocations = response
      })
  }
  displayFn (user: ProduuctsSelect): string {
    return user && user.ItemNumber ? user.ItemNumber : user.ItemDescription
  }

  private _filter (name: string): ProduuctsSelect[] {
    const filterValue = String(name).toLowerCase()

    return this.options.filter(option =>
      option.ItemNumber.toLowerCase().indexOf(filterValue) === 0
        ? option
        : option.ItemDescription.toLowerCase().indexOf(filterValue) === 0
    )
  }
  onKeydown (e) {
    console.log(e, 'teclado')
    this.options = this.options2
    this.autocomplete.openPanel()
    this.datosinicio = ''
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value)),
      map(name => (name ? this._filter(name) : this.options.slice()))
    )
  }
  onselectchanger (da: any) {
    this.options = []
    this.options2 = []
    this.viewLocation = false
    this.viewProdust = false
    this.OnSelectProductsItems()
  }
  OnSelectProductsItems () {
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['customerId'] = Number(
      this.formWarehouseLocationAdd.controls.Customer.value
    )
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProdutsItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ProduuctsSelect[]) => {
        this.myControl.patchValue('', { emitEvent: true })
        this.ArrayProdutsItems = response
        this.options = response
        this.options2 = response
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => (typeof value === 'string' ? value : value)),
          map(name => (name ? this._filter(name) : this.options.slice()))
        )
        this.viewProdust = true
        this.viewLocation = true
        this.viewminOrder=true;
      })
  }
  OnAddlocationUnion (
    id: number,
    tblLocationID: number,
    tblWarehouseNameID: number,
    active: number,
    userName: string,
    minOrder: number,
    tblProductID: number
  ) {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/WarehouseNameLocationUnionInsertUpdate?id=${id}&tblLocationID=${tblLocationID}&tblWarehouseNameID=${tblWarehouseNameID}&active=${active}&userName=${userName}&minOrder=${minOrder}&tblProductID=${tblProductID}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.isedit=false;
        this.idEdit=0;
        this.idproduct=0;
        this.activeEdit=true;
        this.formWarehouseLocationAdd.controls.Active.setValue('1')
        this.formWarehouseLocationAdd.controls.Customer.enable();
this.onTableLocationWarehouse();

      })
  }
  OnAddlocationUnionWithout (

    tblLocationID: number,
    tblWarehouseNameID: number
    
  ) {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/WarehouseNameLocationUnionInsert?LocationID=${tblLocationID}&WarehouseNameID=${tblWarehouseNameID}&active=${1}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
       
this.onTableLocationWarehouseWithout();
      })
  }
  onButtonSaveWithout () {
    this.OnAddlocationUnionWithout(
   
      Number(this.formWarehouseLocationAddWithout.controls.location.value),
      Number(this.data.id)
      
    )
  }
  onButtonSave () {
    this.DatosSelectProduct = this.myControl.value
if (this.isedit) {
  console.log(this.activeEdit)
  this.OnAddlocationUnion(
    this.idEdit,
    Number(this.formWarehouseLocationAdd.controls.location.value),
    Number(this.data.id),
    Number(this.formWarehouseLocationAdd.controls.Active.value),
    this.authenticationService.currentUserValue.useremail,
    Number(this.formWarehouseLocationAdd.controls.minOrder.value),
  this.idproduct
  )
} else {
  this.OnAddlocationUnion(
    0,
    Number(this.formWarehouseLocationAdd.controls.location.value),
    Number(this.data.id),
    Number(this.formWarehouseLocationAdd.controls.Active.value),
    this.authenticationService.currentUserValue.useremail,
    Number(this.formWarehouseLocationAdd.controls.minOrder.value),
    Number(this.DatosSelectProduct.id)
  )
}
    
  }


  onTableLocationWarehouse(){
    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Administracion/WarehouseNameLocationUnionSelectGet?WarehouseNameID=${Number(this.data.id)}`,
      
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: ResponseWarehouseProductsLocation[]) => {
      this.ResponseWarehouseProductsLocation=[]
      this.ResponseWarehouseProductsLocation=response
    })
  }
  onTableLocationWarehouseWithout(){
    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Administracion/WarehouseNameLocationUnionWithoutProductsSelect?WarehouseNameID=${Number(this.data.id)}`,
      
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: ResponseWarehouseProductsLocationWitout[]) => {
      this.ResponseWarehouseProductsLocationWitout=[]
      this.ResponseWarehouseProductsLocationWitout=response
    })
  }
  onDeleteLocationWarehouseWithout(items:ResponseWarehouseProductsLocationWitout){
    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Administracion/WarehouseNameLocationUnionWithoutProductsDelete?ID=${items.id}&WarehouseNameID=${Number(this.data.id)}`,
      
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      }
    )
    .subscribe((response: any[]) => {
this.onTableLocationWarehouseWithout();
    })
  }
  filterDataCustomerSearchOrder (locationName: number) {
    return this.PlaceOrderCustomer.filter(object => {
      if (object['key'] == locationName) {
        return object
      }
    })
  }
  onsearchtextcustomer(id:any){

    var label=""

    try {
      var se=this.filterDataCustomerSearchOrder(Number(id));

      label=se[0].value
    } catch (error) {
      label=""
    }
    return label
  }
  onClearData(){
    this.options=[]
    this.options2=[]
    this.viewProdust=false
    this.viewLocation=false
    this.viewminOrder=false;
    this.isedit=false;
    this.idEdit=0;
    this.idproduct=0
    this.activeEdit=true;
    this.formWarehouseLocationAdd.controls.Customer.enable();
   // this.ResponseWarehouseProductsLocation=[];
   this.myControl.patchValue('', { emitEvent: true })
    this.formWarehouseLocationAdd.reset({
      Customer: [''],
      product: [this.myControl],
      location: [''],
      minOrder: [1]
      ,Active:[1]
    })
  }
onEditarLocationProducts(location:ResponseWarehouseProductsLocation){
  console.log(location,'2')
  this.isedit=true;
  this.idEdit=location.id;
this.activeEdit=Boolean(location.active)
console.log(this.activeEdit)
this.idproduct=location.tblProductID;
  this.formWarehouseLocationAdd.reset({
    Customer: [""],
    product: [this.myControl],
    location: [""],
    minOrder: [0],
    Active:[1]
  })
  this.formWarehouseLocationAdd.controls.Customer.setValue(location.tblCustomerID);
this.formWarehouseLocationAdd.controls.Customer.disable();
this.formWarehouseLocationAdd.controls.location.setValue(location.tblLocationID);
this.formWarehouseLocationAdd.controls.minOrder.setValue(location.minOrder);
this.formWarehouseLocationAdd.controls.Active.setValue(String(location.active));
this.viewProdust = false
        this.viewLocation = true
        this.viewminOrder=true;

}



}
